import React, {useState} from 'react';

const TimeSlotEditor = ({
  timeSlots = [],
  onTimeSelect,
  onEdit,
  onDelete,
  onBlock,
  buttonClasses = "",
  isDisabled = false,
  hideBlockButton = false
}) => {

  const isSlotBlocked = (slot) => {
    if (typeof slot === 'object' && slot !== null) {
      return slot.block_schedule === true;
    }
    return false;
  };


const getTimeText = (slot) => {
  if (typeof slot === 'object') {
    const timeText = slot.time;
    const queueSupplier = slot.queue_supplier;
    if (queueSupplier) {
      return `${timeText} `;
    }
    return timeText;
  }
  return slot;
};

  return (
    <>
      {timeSlots.map((slot, index) => {
        const timeText = getTimeText(slot);
        const isBlocked = isSlotBlocked(slot);
        
        const blockButtonText = isBlocked ? "Desbloquear horario" : "Bloquear horario";
        return (
          <div className="flex items-center gap-2" key={index}>
            <p
              className={`font-robotoregular  text-white p-[8px] text-[14px] rounded-[8px] transition-opacity duration-300 
                ${buttonClasses}
                ${isBlocked ? 'bg-[#D9D9D9]' : 'bg-green'}
                `}
              onClick={() => !isDisabled && onTimeSelect(timeText)}
            >
              {timeText}
            </p>

            { !isDisabled && (
              <>
            {/**EDITAR */}
            <button 
              title="Editar horario"
              disabled={isBlocked || isDisabled}
              className={`group ${isBlocked || isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
              onClick={() => onEdit(slot)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="stroke-gray-500 group-hover:stroke-[#007696]" d="M3 21H21"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path className="stroke-gray-500 group-hover:stroke-[#007696]" d="M7 17V13L17 3L21 7L11 17H7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path className="stroke-gray-500 group-hover:stroke-[#007696]" d="M14 6L18 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path className="stroke-gray-500 group-hover:stroke-[#007696]" d="M14 6L18 10L21 7L17 3L14 6Z" />
                </svg>
            </button>
            {/**BLOQUEAR */}
            {!hideBlockButton && (
            <button 
              onClick={() => onBlock(slot)} 
              className=' group'
              title={blockButtonText}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.59163 15.5032 3.99623 13.7769 4 12ZM12 20C10.15 20 8.45 19.37 7.1 18.31L18.31 7.1C19.4084 8.49679 20.0038 10.2231 20 12C20 16.42 16.42 20 12 20Z"
                 fill={isBlocked ? "#007696" : "#6B7280"}
                 className="group-hover:fill-[#007696] transition-colors duration-200"/>
                </svg>
            </button>
            )}

            {/** ELIMINAR */}
            <button
              onClick={() => onDelete(slot)}
              className='group' 
              title="Eliminar horario" 
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.241 3.721L15.534 5.75H19.5C19.6989 5.75 19.8897 5.82902 20.0303 5.96967C20.171 6.11032 20.25 6.30109 20.25 6.5C20.25 6.69891 20.171 6.88968 20.0303 7.03033C19.8897 7.17098 19.6989 7.25 19.5 7.25H18.731L17.858 17.435C17.805 18.055 17.762 18.565 17.693 18.977C17.623 19.406 17.516 19.79 17.307 20.146C16.9788 20.7051 16.4909 21.1533 15.906 21.433C15.534 21.61 15.142 21.683 14.708 21.717C14.291 21.75 13.78 21.75 13.158 21.75H10.842C10.22 21.75 9.709 21.75 9.292 21.717C8.858 21.683 8.466 21.61 8.094 21.433C7.50908 21.1533 7.02118 20.7051 6.693 20.146C6.483 19.79 6.378 19.406 6.307 18.977C6.238 18.564 6.195 18.055 6.142 17.435L5.269 7.25H4.5C4.30109 7.25 4.11032 7.17098 3.96967 7.03033C3.82902 6.88968 3.75 6.69891 3.75 6.5C3.75 6.30109 3.82902 6.11032 3.96967 5.96967C4.11032 5.82902 4.30109 5.75 4.5 5.75H8.466L8.759 3.721L8.77 3.66C8.952 2.87 9.63 2.25 10.48 2.25H13.52C14.37 2.25 15.048 2.87 15.23 3.66L15.241 3.721ZM9.981 5.75H14.018L13.762 3.974C13.714 3.807 13.592 3.75 13.519 3.75H10.481C10.408 3.75 10.286 3.807 10.238 3.974L9.981 5.75ZM11.25 10.5C11.25 10.3011 11.171 10.1103 11.0303 9.96967C10.8897 9.82902 10.6989 9.75 10.5 9.75C10.3011 9.75 10.1103 9.82902 9.96967 9.96967C9.82902 10.1103 9.75 10.3011 9.75 10.5V15.5C9.75 15.6989 9.82902 15.8897 9.96967 16.0303C10.1103 16.171 10.3011 16.25 10.5 16.25C10.6989 16.25 10.8897 16.171 11.0303 16.0303C11.171 15.8897 11.25 15.6989 11.25 15.5V10.5ZM14.25 10.5C14.25 10.3011 14.171 10.1103 14.0303 9.96967C13.8897 9.82902 13.6989 9.75 13.5 9.75C13.3011 9.75 13.1103 9.82902 12.9697 9.96967C12.829 10.1103 12.75 10.3011 12.75 10.5V15.5C12.75 15.6989 12.829 15.8897 12.9697 16.0303C13.1103 16.171 13.3011 16.25 13.5 16.25C13.6989 16.25 13.8897 16.171 14.0303 16.0303C14.171 15.8897 14.25 15.6989 14.25 15.5V10.5Z"
                 fill="#6B7280"
                 className="group-hover:fill-[#007696] transition-colors duration-200"/>
                </svg>
            </button>
          </>
            )}
          </div>
        );
      })}
    </>
  );
};

export default TimeSlotEditor;